/* Velora Image-Led — kliensoldal. Külső könyvtár nélkül, a téma JS-éhez nem nyúl. */
(() => {
  'use strict';
  if (window.__veloraLoaded) return;
  window.__veloraLoaded = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cfg = window.veloraConfig || {};
  const threshold = Number(cfg.threshold || 0); // fillér (x100)
  const moneyFormat = cfg.moneyFormat || '{{amount_no_decimals_with_comma_separator}} Ft';
  const icon = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" pathLength="1"/></svg>'
  };

  function money(cents) {
    const group = (n, precision, thousands, decimal) => {
      const fixed = (Math.round(n) / 100).toFixed(precision).split('.');
      return fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fixed[1] ? decimal + fixed[1] : '');
    };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: group(cents, 2, ',', '.'),
      amount_no_decimals: group(cents, 0, ',', '.'),
      amount_with_comma_separator: group(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: group(cents, 0, '.', ','),
      amount_no_decimals_with_space_separator: group(cents, 0, ' ', ','),
      amount_with_space_separator: group(cents, 2, ' ', ',')
    }[key] ?? group(cents, 0, '.', ','))).replace(/<[^>]*>/g, '');
  }
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const track = (name, data) => { try { window.Shopify?.analytics?.publish?.(name, data); } catch (_) {} };

  /* ---------- Szállítási üzenet ---------- */
  function shippableTotal(cart) {
    return Math.max(0, Number(cart.total_price || 0) - (cart.items || []).reduce((sum, item) =>
      sum + (item.requires_shipping === false ? Number(item.final_line_price || 0) : 0), 0));
  }

  function shipState(total) {
    if (!threshold) return null;
    const left = threshold - total;
    return { left, pct: Math.max(0, Math.min(100, Math.round(total / threshold * 100))) };
  }
  // Elérve: zöld pipa és zöld sáv (mindenhol ugyanígy).
  function shipHTML(total) {
    const st = shipState(total);
    if (!st) return '';
    const free = st.left <= 0;
    const text = free ? `${icon.check}Ingyenes szállítással érkezik` : `Még ${money(st.left)}, és ingyenes a szállítás`;
    return `<p class="v-ship__text${free ? ' is-free' : ''}">${text}</p><div class="v-ship__bar${free ? ' is-free' : ''}" aria-hidden="true"><span style="--v-progress:${st.pct}%"></span></div>`;
  }
  // Helyben frissít (a sáv így finoman tölt), és ha most lett ingyenes, rövid visszajelzést ad.
  function renderShip(el, total) {
    const st = shipState(total);
    if (!st) { el.innerHTML = ''; return; }
    const free = st.left <= 0;
    const wasFree = el.dataset.vFree;
    const text = el.querySelector('.v-ship__text');
    const bar = el.querySelector('.v-ship__bar');
    if (!text || !bar) el.innerHTML = shipHTML(total);
    else {
      text.classList.toggle('is-free', free);
      text.innerHTML = free ? `${icon.check}Ingyenes szállítással érkezik` : `Még ${money(st.left)}, és ingyenes a szállítás`;
      bar.classList.toggle('is-free', free);
      bar.querySelector('span')?.style.setProperty('--v-progress', `${st.pct}%`);
    }
    el.dataset.vFree = free ? '1' : '0';
    if (free && wasFree === '0') {
      el.classList.remove('is-unlocked');
      void el.offsetWidth;
      el.classList.add('is-unlocked');
      clearTimeout(el.vUnlockTimer);
      el.vUnlockTimer = setTimeout(() => el.classList.remove('is-unlocked'), 1800);
    }
  }
  async function getCart() {
    const r = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!r.ok) throw new Error('Cart unavailable');
    return r.json();
  }
  async function refreshCartBubble() {
    try {
      const r = await fetch(`${root}?sections=cart-icon-bubble`, { credentials: 'same-origin' });
      const data = await r.json();
      const target = document.getElementById('cart-icon-bubble');
      if (target && data['cart-icon-bubble']) {
        const tmp = document.createElement('div');
        tmp.innerHTML = data['cart-icon-bubble'];
        const fresh = tmp.querySelector('#cart-icon-bubble') || tmp.firstElementChild;
        target.innerHTML = fresh ? fresh.innerHTML : target.innerHTML;
        const bubble = target.querySelector('.cart-count-bubble') || target;
        bubble.classList.remove('v-bump');
        void bubble.offsetWidth;
        bubble.classList.add('v-bump');
      }
    } catch (_) { /* a számláló a következő oldalbetöltéskor frissül */ }
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(html) {
    let el = document.querySelector('.v-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'v-toast v-scope';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.append(el);
    }
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 6000);
  }

  async function addToCart(variantId, quantity, source) {
    let r, body;
    try {
      r = await fetch(`${root}cart/add.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
      });
      body = await r.json();
    } catch (_) {
      throw new Error('Nem sikerült kosárba tenni. Ellenőrizd az internetkapcsolatot, és próbáld újra.');
    }
    if (!r.ok) throw new Error(typeof body.description === 'string' ? body.description : 'Nem sikerült kosárba tenni.');
    track('velora_quick_add', { variant_id: Number(variantId), source });
    // A szállításválasztó ablakban (kosároldal) nem töltjük újra az oldalt: az ablak nyitva marad,
    // az összeg és az ingyenes szállítás sáv helyben frissül (velora-delivery.js).
    const inChooser = document.documentElement.classList.contains('vd-lock');
    // Kosároldalon a téma kosárlistáját csak újratöltéssel lehet biztosan frissíteni.
    if (/\/cart\/?$/.test(location.pathname) && !inChooser) { location.reload(); return body; }
    const cart = await getCart().catch(() => null);
    refreshCartBubble();
    const item = body.items?.[0];
    if (!inChooser && !document.querySelector('velora-essential-cart')?.bound) toast(`<div class="v-toast__row"><span>${esc(item?.product_title || 'A termék')} a kosárban.</span><a href="${root}cart">Kosár</a></div>${cart?.requires_shipping ? shipHTML(shippableTotal(cart)) : ''}`);
    document.dispatchEvent(new CustomEvent('velora:cart-changed', { detail: { item, source, cart } }));
    return body;
  }

  /* ---------- Kártya: lapozható képek, pöttyök, swatch ---------- */
  // A 3. képtől a képek csak az első érintéskor / lapozáskor töltődnek be.
  function hydrateSlides(slides) {
    if (!slides || slides.dataset.vHydrated) return;
    slides.dataset.vHydrated = '1';
    slides.querySelectorAll('img[data-v-defer]').forEach(img => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-v-defer');
    });
  }
  document.addEventListener('pointerdown', e => {
    hydrateSlides(e.target instanceof Element ? e.target.closest('[data-v-slides]') : null);
  }, { capture: true, passive: true });
  document.addEventListener('scroll', e => {
    const slides = e.target;
    if (!(slides instanceof Element) || !slides.matches('[data-v-slides]')) return;
    hydrateSlides(slides);
    const idx = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
    slides.parentElement.querySelectorAll('.v-card__dots span').forEach((d, i) => d.classList.toggle('is-active', i === idx));
  }, { capture: true, passive: true });

  function onSwatch(btn) {
    const card = btn.closest('[data-v-card]');
    if (!card) return;
    card.querySelectorAll('[data-v-swatch]').forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
    const img = card.querySelector('[data-v-main-slide] img');
    if (img && btn.dataset.image) {
      const base = btn.dataset.image.replace(/([?&])width=\d+/, '$1').replace(/[?&]$/, '');
      const join = base.includes('?') ? '&' : '?';
      img.srcset = [270, 360, 540, 720].map(w => `${base}${join}width=${w} ${w}w`).join(', ');
      img.src = `${base}${join}width=540`;
    }
    const slides = card.querySelector('[data-v-slides]');
    if (slides) slides.scrollTo({ left: 0 });
    if (btn.dataset.url) {
      card.querySelectorAll('[data-v-main-slide], [data-v-name-link], .v-card__slide').forEach(a => a.setAttribute('href', btn.dataset.url));
    }
    const qa = card.querySelector('[data-v-quick-add]');
    if (qa) qa.dataset.preselect = btn.dataset.variantId || '';
    const badge = card.querySelector('[data-v-badge-slot] .v-badge');
    if (badge) {
      if (btn.dataset.stock) {
        badge.textContent = `Már csak ${btn.dataset.stock} db`;
        badge.className = 'v-badge v-badge--stock';
        badge.hidden = false;
      } else {
        badge.textContent = badge.dataset.vBadgeDefault || '';
        badge.className = `v-badge ${badge.dataset.vBadgeClass || ''}`;
        badge.hidden = !badge.dataset.vBadgeDefault;
      }
    }
  }

  /* ---------- Quick-add panel többvariánsos termékhez ---------- */
  let qaDialog;
  function ensureQaDialog() {
    if (qaDialog) return qaDialog;
    qaDialog = document.createElement('dialog');
    qaDialog.className = 'v-sheet v-scope';
    qaDialog.setAttribute('aria-labelledby', 'VQaTitle');
    qaDialog.innerHTML = `<div class="v-sheet__head"><h2 id="VQaTitle">Válaszd ki a változatot</h2><button type="button" class="v-sheet__close" data-v-close-sheet aria-label="Bezárás">${icon.close}</button></div>
      <div class="v-sheet__body" data-v-qa-body></div>
      <div class="v-sheet__foot"><button type="button" class="v-btn" data-v-qa-submit disabled>Kosárba teszem</button></div>`;
    document.body.append(qaDialog);
    qaDialog.addEventListener('click', e => { if (e.target === qaDialog) qaDialog.close(); });
    return qaDialog;
  }
  function optionTitle(options) {
    const names = options.filter(o => o.values.length > 1).map(o => o.name.toLowerCase());
    if (!names.length) return 'Kosárba teszed?';
    return `Válaszd ki: ${names.join(' és ')}`;
  }
  async function openQuickAdd(btn) {
    const dlg = ensureQaDialog();
    const body = dlg.querySelector('[data-v-qa-body]');
    const submit = dlg.querySelector('[data-v-qa-submit]');
    body.innerHTML = '<p style="padding:16px 0">Betöltés…</p>';
    submit.disabled = true;
    submit.textContent = 'Kosárba teszem';
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    let product;
    try {
      const r = await fetch(`${root}products/${encodeURIComponent(btn.dataset.handle)}.js`, { credentials: 'same-origin' });
      if (!r.ok) throw new Error();
      product = await r.json();
    } catch (_) {
      body.innerHTML = '<p style="padding:16px 0">A termék most nem tölthető be. Nyisd meg a termékoldalt.</p>';
      return;
    }
    const options = product.options.map((o, i) => ({ name: o.name || o, values: o.values || [...new Set(product.variants.map(v => v.options[i]))] }));
    const pre = product.variants.find(v => String(v.id) === btn.dataset.preselect);
    const selected = options.map((o, i) => (o.values.length === 1 ? o.values[0] : (pre ? pre.options[i] : null)));
    dlg.querySelector('#VQaTitle').textContent = optionTitle(options);

    const find = () => product.variants.find(v => v.options.every((val, i) => val === selected[i]));
    const stockLabel = product.tags?.includes('velora-coming-soon') ? 'Hamarosan érkezik' : 'Elfogyott';
    const render = () => {
      const v = selected.every(Boolean) ? find() : null;
      const img = v?.featured_image?.src || product.featured_image;
      body.innerHTML = `<div class="v-qa-sheet__product">${img ? `<img src="${esc(img)}${img.includes('?') ? '&' : '?'}width=160" alt="" width="64" height="80">` : ''}
        <div><p class="v-qa-sheet__name">${esc(product.title)}</p><p class="v-qa-sheet__price">${money(v ? v.price : product.price)}</p></div></div>
        ${options.map((o, i) => o.values.length < 2 ? '' : `<div class="v-opt" role="group" aria-label="${esc(o.name)}"><p class="v-opt__label">${esc(o.name)}</p><div class="v-opt__values">${o.values.map(val => {
          const test = selected.slice(); test[i] = val;
          const exists = product.variants.find(x => x.options.every((ov, k) => test[k] == null || ov === test[k]) && x.available);
          return `<button type="button" class="v-opt__value" data-i="${i}" data-val="${esc(val)}" aria-pressed="${selected[i] === val}" data-unavailable="${!exists}">${esc(val)}</button>`;
        }).join('')}</div></div>`).join('')}
        <p class="v-qa-sheet__status" data-v-qa-status>${v && !v.available ? stockLabel : ''}</p>`;
      submit.disabled = !(v && v.available);
      submit.textContent = v && !v.available ? stockLabel : 'Kosárba teszem';
      submit.dataset.variantId = v ? v.id : '';
    };
    body.onclick = e => {
      const b = e.target.closest('.v-opt__value');
      if (!b) return;
      selected[Number(b.dataset.i)] = b.dataset.val;
      render();
      body.querySelector(`.v-opt__value[data-i="${b.dataset.i}"][aria-pressed="true"]`)?.focus();
    };
    submit.onclick = async () => {
      if (!submit.dataset.variantId) return;
      submit.disabled = true;
      submit.textContent = 'Kosárba kerül…';
      try {
        await addToCart(submit.dataset.variantId, 1, 'card_sheet');
        dlg.close();
      } catch (err) {
        const st = body.querySelector('[data-v-qa-status]');
        if (st) st.textContent = err.message;
        submit.disabled = false;
        submit.textContent = 'Kosárba teszem';
      }
    };
    render();
  }

  /* ---------- Delegált kattintások ---------- */
  document.addEventListener('click', async e => {
    const swatch = e.target.closest('[data-v-swatch]');
    if (swatch) { onSwatch(swatch); return; }

    const qa = e.target.closest('[data-v-quick-add]');
    if (qa && !qa.disabled) {
      if (qa.dataset.variantId) {
        qa.disabled = true;
        try { await addToCart(qa.dataset.variantId, 1, 'card'); }
        catch (err) {
          if (document.documentElement.classList.contains('vd-lock')) {
            document.dispatchEvent(new CustomEvent('velora:cart-add-error', { detail: { message: err.message } }));
          } else {
            toast(`<div class="v-toast__row"><span>${esc(err.message)}</span></div>`);
          }
        }
        finally { qa.disabled = false; }
      } else {
        openQuickAdd(qa);
      }
      return;
    }

    const open = e.target.closest('[data-v-open-sheet]');
    if (open) {
      const dlg = document.getElementById(open.dataset.vOpenSheet);
      if (dlg?.showModal) dlg.showModal();
      return;
    }
    const close = e.target.closest('[data-v-close-sheet]');
    if (close) { close.closest('dialog')?.close(); return; }
    if (e.target instanceof HTMLDialogElement && e.target.classList.contains('v-sheet')) { e.target.close(); return; }

    const more = e.target.closest('[data-v-ugc-more]');
    if (more) {
      const wrap = more.closest('[data-v-ugc]');
      const on = !wrap.classList.contains('is-expanded');
      wrap.classList.toggle('is-expanded', on);
      more.setAttribute('aria-expanded', String(on));
      more.textContent = on ? 'Kevesebb' : 'Mutass többet';
      return;
    }

    const ann = e.target.closest('[data-v-announce]');
    if (ann && !e.target.closest('a')) ann.classList.toggle('is-paused');
  });

  document.addEventListener('change', e => {
    if (e.target.matches('[data-v-autosubmit]')) e.target.form?.submit();
  });

  /* ---------- Sticky eszközsor a header alá ---------- */
  function headerOffset() {
    const header = document.querySelector('sticky-header, .section-header, .shopify-section-header-sticky');
    if (!header) return;
    const pos = getComputedStyle(header).position;
    const h = pos === 'sticky' || pos === 'fixed' ? Math.round(header.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--v-header-offset', `${h}px`);
  }

  /* ---------- Lábléc: desktopon nyitott oszlopok ---------- */
  function footerColumns() {
    const open = window.matchMedia('(min-width: 990px)').matches;
    document.querySelectorAll('[data-v-footer-cols] details').forEach(d => { if (open) d.open = true; });
  }

  /* Keep recommendation disclosure state for this page view, including replaced sections. */
  const cartRecsOpen = new Map();
  function restoreCartRecs(root = document) {
    const hosts = root.matches?.('[data-v-cart-recs]') ? [root] : root.querySelectorAll('[data-v-cart-recs]');
    hosts.forEach(host => {
      const button = host.querySelector('[data-v-recs-toggle]');
      const panel = host.querySelector('[data-v-recs-panel]');
      if (!button || !panel) return;
      const open = cartRecsOpen.get(host.dataset.sectionId) === true;
      const expanded = String(open);
      if (button.getAttribute('aria-expanded') !== expanded) button.setAttribute('aria-expanded', expanded);
      panel.classList.toggle('is-open', open);
      panel.inert = !open;
    });
  }
  window.VeloraCartRecs = { restore: restoreCartRecs };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-v-recs-toggle]');
    if (!button) return;
    const host = button.closest('[data-v-cart-recs]');
    cartRecsOpen.set(host.dataset.sectionId, button.getAttribute('aria-expanded') !== 'true');
    restoreCartRecs(host);
  });
  let cartRecsBound = false;
  function initCartRecs() {
    restoreCartRecs();
    if (cartRecsBound || !document.body) return;
    cartRecsBound = true;
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches('[data-v-cart-recs], [data-v-recs-panel]') || node.querySelector('[data-v-cart-recs], [data-v-recs-panel]'))))) restoreCartRecs();
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Kosároldal: haladásjelző frissítése ---------- */
  let cartProgressBound = false;
  function initCartProgress() {
    const box = document.querySelector('[data-v-ship]');
    if (!box && !document.querySelector('[data-v-ship-empty]')) return;
    if (cartProgressBound) return;
    cartProgressBound = true;
    let busy = false, again = false;
    const update = async () => {
      if (busy) { again = true; return; }
      busy = true;
      try {
        const cart = await getCart();
        let el = document.querySelector('[data-v-ship]');
        if (!el) {
          const holder = document.querySelector('[data-v-ship-empty]');
          if (!holder) return;
          el = document.createElement('div');
          el.className = 'v-ship';
          el.setAttribute('data-v-ship', '');
          holder.append(el);
        }
        el.hidden = cart.item_count === 0 || !cart.requires_shipping;
        el.setAttribute('aria-live', 'polite');
        renderShip(el, shippableTotal(cart));
        document.querySelectorAll('[data-v-physical-only]').forEach(node => { node.hidden = !cart.requires_shipping; });
        document.querySelectorAll('[data-v-checkout-label]').forEach(node => {
          const label = 'Tovább a fizetéshez';
          if (node.textContent !== label) node.textContent = label;
        });
        document.dispatchEvent(new CustomEvent('velora:cart-synced', { detail: { cart } }));
      } catch (_) {} finally {
        busy = false;
        if (again) { again = false; update(); }   // közben érkezett változás: a legfrissebb összeggel újra
      }
    };
    let timer;
    const schedule = () => { clearTimeout(timer); timer = setTimeout(update, 100); };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }
    document.addEventListener('velora:cart-changed', schedule);
    if (document.body && 'MutationObserver' in window) {
      new MutationObserver(records => {
        if (records.some(record => record.target.closest?.('cart-items, #main-cart-items, #main-cart-footer') ||
          [...record.addedNodes].some(node => node.matches?.('cart-items, #main-cart-items, #main-cart-footer')))) schedule();
      }).observe(document.body, { childList: true, subtree: true });
    }
    update();
  }

  /* ---------- Görgetéskor finoman megjelenő szakaszok ----------
     Csak ami a betöltéskor még nem látszik; a témaszerkesztőben és „kevesebb mozgás” beállításnál nincs.
     Biztonsági háló: 2,5 mp után minden megjelölt elem látható lesz, akkor is, ha a figyelő nem jelezne. */
  const REVEAL = '.v-section > .v-title, .v-title.v-wrap, .v-rail, .v-grid, .v-brand, .v-collage, .v-howto, .v-feature, .v-cbase, .v-faq .v-acc, .v-ugc .v-rail';
  let revealObserver = null;
  function initReveal() {
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    }
    const fold = window.innerHeight;
    const marked = [];
    document.querySelectorAll(REVEAL).forEach(el => {
      if (el.dataset.vReveal || el.closest('.vd, dialog, .v-toast') || el.parentElement?.closest('.v-reveal')) return;
      el.dataset.vReveal = '1';
      if (el.getBoundingClientRect().top < fold) return;   // már látszik: nem animáljuk
      el.classList.add('v-reveal');
      revealObserver.observe(el);
      marked.push(el);
    });
    if (!marked.length) return;
    // tartalék: ha a figyelő valamiért nem jelezne, görgetéskor akkor is megjelenik
    let ticking = false;
    const check = () => {
      ticking = false;
      const pending = document.querySelectorAll('.v-reveal:not(.is-in)');
      pending.forEach(el => { if (el.getBoundingClientRect().top < window.innerHeight * .96) el.classList.add('is-in'); });
      if (!pending.length) window.removeEventListener('scroll', onScroll);
    };
    const onScroll = () => { if (!ticking) { ticking = true; setTimeout(check, 400); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(check, 2500);
  }

  let sliderLabelsBound = false;
  function initSliderLabels() {
    if (sliderLabelsBound || !document.body) return;
    sliderLabelsBound = true;
    const translate = node => {
      if (!node.closest?.('.splide, splide-component, [class*="ai-image-slider"]')) return;
      const label = node.getAttribute('aria-label');
      const translations = { 'Previous slide': 'Előző kép', 'Next slide': 'Következő kép',
        'Go to first slide': 'Első kép', 'Go to last slide': 'Utolsó kép',
        'Start autoplay': 'Automatikus lejátszás indítása', 'Pause autoplay': 'Automatikus lejátszás szüneteltetése',
        'Select a slide to show': 'Válassz egy képet' };
      const translated = translations[label] || label?.replace(/^Go to slide (\d+)$/, 'Ugrás a(z) $1. képre').replace(/^Go to page (\d+)$/, 'Ugrás a(z) $1. oldalra');
      if (translated && translated !== label) node.setAttribute('aria-label', translated);
      const role = node.getAttribute('aria-roledescription');
      if (role === 'carousel' || role === 'slide') node.setAttribute('aria-roledescription', role === 'carousel' ? 'Képgaléria' : 'Kép');
    };
    const scan = node => {
      if (node.nodeType !== 1) return;
      translate(node);
      node.querySelectorAll('[aria-label], [aria-roledescription]').forEach(translate);
    };
    scan(document.body);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') translate(record.target);
      else record.addedNodes.forEach(scan);
    })).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'aria-roledescription'] });
  }

  function init() {
    headerOffset();
    footerColumns();
    initCartProgress();
    initCartRecs();
    initReveal();
    initSliderLabels();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('resize', () => { headerOffset(); footerColumns(); }, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
